// this.$store.state.agendaPlanBusiness
import { db } from "@/firebase";
import {
  doc,
  query,
  collection,
  where,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
  orderBy,
} from "firebase/firestore";
import moment from "moment";

// AGENDA PLAN BUSINESS
export const agendaPlanBusiness = {
  objeto: class {
    constructor() {
      return {
        id: "",
        fecha: "",
        horaInicio: "",
        duracion: 1,
        rangoHorario: "",
        cliente: "",
        empresa: "",
        correo: "",
        telefono: "",
        estado: "reservado",
        registro: {
          filtro: moment().format("YYYY-MM-DD"),
          estado: "Creado",
          idUsuario: "",
          creacion: serverTimestamp(),
          actualizacion: serverTimestamp(),
        },
      };
    }
  },
  funciones: {
    async crear(cita) {
      await setDoc(
        doc(db, "riskmann_empresas_planes_business_agenda", cita.id),
        cita,
      );
    },
    async actualizar(cita) {
      await updateDoc(
        doc(db, "riskmann_empresas_planes_business_agenda", cita.id),
        {
          fecha: cita.fecha,
          horaInicio: cita.horaInicio,
          duracion: cita.duracion,
          rangoHorario: cita.rangoHorario,
          cliente: cita.cliente,
          empresa: cita.empresa,
          correo: cita.correo,
          telefono: cita.telefono,
          estado: cita.estado,
          "registro.estado": "Editado",
          "registro.actualizacion": serverTimestamp(),
        },
      );
    },
    async cancelar(id) {
      await updateDoc(
        doc(db, "riskmann_empresas_planes_business_agenda", id),
        {
          estado: "cancelado",
          "registro.estado": "Editado",
          "registro.actualizacion": serverTimestamp(),
        },
      );
    },
    async eliminar(id) {
      await updateDoc(
        doc(db, "riskmann_empresas_planes_business_agenda", id),
        {
          "registro.estado": "Eliminado",
          "registro.actualizacion": serverTimestamp(),
        },
      );
    },
    async obtener(id) {
      const q = query(
        collection(db, "riskmann_empresas_planes_business_agenda"),
        where("id", "==", id),
        where("registro.estado", "in", ["Creado", "Editado"]),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs[0].data()
        : null;
    },
    async obtenerPorFecha(fecha) {
      const q = query(
        collection(db, "riskmann_empresas_planes_business_agenda"),
        where("fecha", "==", fecha),
        where("estado", "==", "reservado"),
        where("registro.estado", "in", ["Creado", "Editado"]),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs.map((doc) => doc.data())
        : [];
    },
    async obtenerPorRangoFechas(fechaInicio, fechaFin) {
      const q = query(
        collection(db, "riskmann_empresas_planes_business_agenda"),
        where("fecha", ">=", fechaInicio),
        where("fecha", "<=", fechaFin),
        where("registro.estado", "in", ["Creado", "Editado"]),
        orderBy("fecha"),
        orderBy("horaInicio"),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs.map((doc) => doc.data())
        : [];
    },
    async generarID() {
      const refCita = doc(
        collection(db, "riskmann_empresas_planes_business_agenda"),
      );
      return refCita.id;
    },
  },
};
